import * as ambassadorWixEcomRecommendationsV1Recommendation from './ecom-recommendations-v1-recommendation-recommendations.http.js';
import * as ambassadorWixEcomRecommendationsV1RecommendationTypes from './ecom-recommendations-v1-recommendation-recommendations.types.js';
import * as ambassadorWixEcomRecommendationsV1RecommendationUniversalTypes from './ecom-recommendations-v1-recommendation-recommendations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listAvailableAlgorithms(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomRecommendationsV1RecommendationUniversalTypes.ListAvailableAlgorithmsRequest,
  ambassadorWixEcomRecommendationsV1RecommendationTypes.ListAvailableAlgorithmsRequest,
  ambassadorWixEcomRecommendationsV1RecommendationUniversalTypes.ListAvailableAlgorithmsResponse,
  ambassadorWixEcomRecommendationsV1RecommendationTypes.ListAvailableAlgorithmsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomRecommendationsV1Recommendation.listAvailableAlgorithms(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/recommendations/algorithms',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRecommendation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomRecommendationsV1RecommendationUniversalTypes.GetRecommendationRequest,
  ambassadorWixEcomRecommendationsV1RecommendationTypes.GetRecommendationRequest,
  ambassadorWixEcomRecommendationsV1RecommendationUniversalTypes.GetRecommendationResponse,
  ambassadorWixEcomRecommendationsV1RecommendationTypes.GetRecommendationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomRecommendationsV1Recommendation.getRecommendation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/recommendations/get',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Recommendation as RecommendationOriginal,
  CatalogReference as CatalogReferenceOriginal,
  Algorithm as AlgorithmOriginal,
  ListAvailableAlgorithmsRequest as ListAvailableAlgorithmsRequestOriginal,
  ListAvailableAlgorithmsResponse as ListAvailableAlgorithmsResponseOriginal,
  AlgorithmInfo as AlgorithmInfoOriginal,
  AlgorithmConfig as AlgorithmConfigOriginal,
  AlgorithmType as AlgorithmTypeOriginal,
  AlgorithmTypeWithLiterals as AlgorithmTypeWithLiteralsOriginal,
  GetRecommendationRequest as GetRecommendationRequestOriginal,
  GetRecommendationResponse as GetRecommendationResponseOriginal,
  ItemAppIdNotSupportedByProvider as ItemAppIdNotSupportedByProviderOriginal,
  RecommendationAlgorithmNotSupported as RecommendationAlgorithmNotSupportedOriginal,
  GetRecommendationApplicationErrors as GetRecommendationApplicationErrorsOriginal,
} from './ecom-recommendations-v1-recommendation-recommendations.types.js';
